document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("zennia-builder");
  if (!container) return;

  const braceletSize = 17;

  let braceletStyle = "silver";
  let selectedSlot = null;

  // 👉 BASE IMAGES
  const BASES = {
    silver: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/silverBase.png?v=1776436542",
    gold: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/goldBase.png?v=1776435004",
    wrapped: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/silverGoldBase.png?v=1776434993",
    black: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/blackBase.png?v=1776438511"
  };

  const STYLE_PREVIEWS = {
  silver: BASES.silver,
  gold: BASES.gold,
  wrapped: BASES.wrapped,
  black: BASES.black,
  alternate: null // we’ll handle separately
};

  const BASE_VARIANT_ID = 42961572397104; // your bracelet

  const BASE_VARIANTS = {
  silver: 42961572397104,
  gold: 42961983602736,
  wrapped: 42961984520240,
  black: 42961984389168,
  alternate: 42961991827504 // or whichever you want
  };

  // 👉 NORMAL CHARMS (already full images)
  const charms = [
    { id: "letterS",name: "Letter S",variantId: 42961557618736, price: 120, img: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/1.png?v=1776426844" },
    { id: "letterA",name: "Letter A",variantId: 42961568432176, price: 120, img: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/2.png?v=1776426844" },
    { id: "letterU",name: "Letter U",variantId: 42961557618736, price: 120, img: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/3.png?v=1776426844" },
    { id: "girlyGirl",name: "Girly Girl",variantId: 42961569218608, price: 120, img: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/girly_girl.png?v=1776431730" },
    { id: "goldenPinkHeart",name:"Golden Pink Heart",variantId:42963717521456,price:120,img:"https://cdn.shopify.com/s/files/1/0614/2371/4352/files/GoldenPinkHeartCharm_6c47d441-96bd-47e5-99bf-fb3e86d636d9.png?v=1776575022"},
    { id: "goldenButterfly",name:"Golden Butterfly",variantId:42963859603504,price:120,img:"https://cdn.shopify.com/s/files/1/0614/2371/4352/files/GoldenButterflyCharm.png?v=1776573559"}
  ];

  // 👉 HANGING CHARMS (IMPORTANT: must be FULL LINK images)
  const hangingCharms = [
    {
      id: "pinkBow",
      name: "Blue Hanging Heart",variantId: 42961568497712, price: 80,
      img: "https://cdn.shopify.com/s/files/1/0614/2371/4352/files/Untitled_600_x_1060_px.png?v=1776453143"
    }
  ];

  // 👉 INITIAL SLOTS
  let slots = Array(braceletSize).fill().map(() => ({
    type: "base",
    img: getBaseImage(0)
  }));

  function updateBaseSlots() {
  slots = slots.map((slot, index) => {
    if (slot.type === "base") {
      return {
        type: "base",
        img: getBaseImage(index)
      };
    }
    return slot;
  });
}
  function getSummary() {
  const map = {};

  slots.forEach(slot => {
    if (!slot || slot.type === "base") return;

    const charmData = [...charms, ...hangingCharms].find(c => c.img === slot.img);

    if (!charmData) return;

    if (!map[charmData.id]) {
      map[charmData.id] = {
        ...charmData,
        count: 0
      };
    }

    map[charmData.id].count++;
  });

  return Object.values(map);
}
const BASE_PRICES = {
  silver: 180,
  gold: 180,
  wrapped: 200,
  black: 250
};

function getBaseImage(index) {
  if (braceletStyle === "alternate") {
    return index % 2 === 0 ? BASES.silver : BASES.gold;
  }

  return BASES[braceletStyle];
}

function getReadableDesign() {
  let result = `Style: ${braceletStyle}\n\n`;

  slots.forEach((slot, i) => {
    let text = "Empty";

    if (slot.type !== "base") {
      const charmData = [...charms, ...hangingCharms].find(c => c.img === slot.img);
      if (charmData) {
        text = charmData.name + (slot.type === "hanging" ? " (Hanging)" : "");
      }
    }

    result += `${i + 1}: ${text}\n`;
  });

  return result;
}

function getSlotsForCharm(charmId) {
  let positions = [];

  slots.forEach((slot, i) => {
    const charmData = [...charms, ...hangingCharms].find(c => c.img === slot.img);
    if (charmData && charmData.id === charmId) {
      positions.push(`Slot ${i + 1}`);
    }
  });

  return positions.join(", ");
}

function saveDesign() {
  localStorage.setItem("zennia_design", JSON.stringify({
    style: braceletStyle,
    slots: slots
  }));
}

function loadDesign() {
  const saved = localStorage.getItem("zennia_design");

  if (!saved) return;

  try {
    const data = JSON.parse(saved);

    if (data.style) braceletStyle = data.style;
    if (data.slots) slots = data.slots;

  } catch (e) {
    console.log("Failed to load design");
  }
}

function generateShareLink() {
  const data = {
    style: braceletStyle,
    slots: slots
  };

  const encoded = btoa(JSON.stringify(data));

  return `${window.location.origin}${window.location.pathname}?design=${encoded}`;
}

function loadFromURL() {
  const params = new URLSearchParams(window.location.search);
  const design = params.get("design");

  if (!design) return;

  try {
    const decoded = JSON.parse(atob(design));

    if (decoded.style) braceletStyle = decoded.style;
    if (decoded.slots) slots = decoded.slots;

  } catch (e) {
    console.log("Invalid design in URL");
  }
}

  function render() {
    updateBaseSlots();

    const scrollContainer = container.querySelector(".bracelet-scroll");
    const scrollLeft = scrollContainer ? scrollContainer.scrollLeft : 0;

    container.innerHTML = `
    <style>
    .slot img {
      transition: transform 0.2s ease, filter 0.2s ease;
    }
    .slot {
      transition: transform 0.2s ease;
      display:flex;
  align-items:center;
  justify-content:center;
    }

    .slot:hover {
      transform: translateY(-4px) scale(1.05);
      z-index: 2;
      filter: drop-shadow(0 4px 6px rgba(0,0,0,0.15));
    }  

    
    .slot {
  position: relative;
  overflow: visible;
  z-index: 1;
  pointer-events: auto;
}

.slot:hover {
  z-index: 10;
}

    .slot::after {
      content: "";
      position: absolute;
      top: 0;
      left: -75%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
                  120deg,
                  transparent,
                rgba(255,255,255,0.6),
                  transparent
                );
      transform: skewX(-20deg);
      }

     .slot:hover::after {
      animation: shine 0.6s ease forwards;
      }

      @keyframes shine {
      0% {
      left: -75%;
      }
      100% {
      left: 125%;
      }
      } 

      .bracelet-row::-webkit-scrollbar {
              display: none;
      }

      body {
        overflow-x: hidden;
      }

      .bracelet-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.bracelet-scroll::-webkit-scrollbar {
  display: none;
}

@media (min-width: 768px) {
  .bracelet-scroll {
    overflow-x: hidden !important;
  }

  .bracelet-row {
    justify-content: center !important;
  }
}
    }

  .style-circle {
    transition: transform 0.2s ease;
  }

  button[data-remove]:hover {
  color: #000;
  }

  [data-style]:hover .style-circle {
  transform: scale(1.08);
  }


  </style>

  


 <div style="
  text-align:center;
  margin-top:10px;
  font-size:12px;
  letter-spacing:1px;
  color:#777;
">
  ${braceletStyle.toUpperCase()}
</div>




      <div style="text-align:center; margin-bottom:20px;">
        <div style="margin-bottom:8px;">Choose Style</div>

        <div style="display:flex; justify-content:center; gap:14px; flex-wrap:wrap;">
  ${[...Object.keys(BASES), "alternate"].map(style => `
    <div data-style="${style}" style="
      cursor:pointer;
      text-align:center;
    ">
      
      <div class="style-circle" style="
        width:50px;
        height:50px;
        border-radius:50%;
        overflow:hidden;
        border:2px solid ${braceletStyle === style ? '#d4af37' : '#ddd'};
        display:flex;
        align-items:center;
        justify-content:center;
        background:#fff;
      ">
        ${
          style === "alternate"
            ? `
              <div style="display:flex; width:100%; height:100%;">
                <img src="${BASES.silver}" style="width:50%;">
                <img src="${BASES.gold}" style="width:50%;">
              </div>
            `
            : `<img src="${STYLE_PREVIEWS[style]}" style="width:100%; height:100%; object-fit:cover;">`
        }
      </div>

      <div style="font-size:11px; margin-top:4px; color:#555;">
        ${style === "alternate" ? "Mixed" : style}
      </div>
    </div>
  `).join('')}
  </div>
</div>
      </div>

      <div style="margin:40px auto; max-width:900px; overflow:hidden;">
  <div class="bracelet-scroll">
    <div class="bracelet-row" style="
      display:flex;
      justify-content:flex-start;
      min-width:max-content;
      padding:10px 0;
    ">



        ${slots.map((slot, index) => `
          <div class="slot" data-index="${index}" style="
            width:55px;
            height:${slot.type === 'hanging' ? '140px' : '55px'};
            margin-right:-7px;
            margin-top: ${slot.type === 'hanging' ? '5px' : '0'};
            cursor:pointer;
            border:${selectedSlot === index ? '2px solid gold' : 'none'};
          ">



            <div style="position:relative; width:100%; height:100%;">




            <img src="${slot.img}" style="
            pointer-events:none;
  ${slot.type === 'hanging' ? `
    width:55px;
    height:auto;
    position:relative;
    top:11px;
    transform: scale(1.15);
  ` : slot.type === 'charm' ? `
    width:100%;
    height:100%;
    object-fit:cover;
    image-rendering:auto;
    transform: scale(1.25);
  ` : `
    width:100%;
    height:100%;
  `}
">




            </div>

            
          </div>
        `).join('')}
    </div>
  </div>
</div>

<!-- NORMAL CHARMS -->
      <div style="display:flex; justify-content:center; gap:14px;">
        ${charms.map((charm, i) => `
          <div data-charm="${i}" style="width:65px; height:65px; cursor:pointer;">
            <img src="${charm.img}" style="width:100%; height:100%">
          </div>
        `).join('')}
      </div>

      <!-- HANGING CHARMS -->
      <div style="margin-top:20px; text-align:center;">
        <div>Hanging Charms</div>
        <div style="display:flex; justify-content:center; gap:10px;">
          ${hangingCharms.map((charm, i) => `
            <div data-hanging="${i}" style="width:65px; height:65px; cursor:pointer;">
              <img src="${charm.img}" style="width:100%; height:100%;">
            </div>
          `).join('')}
        </div>
      </div>
    `;

const summary = getSummary();

const basePrice = BASE_PRICES[braceletStyle] || 200;

const charmsTotal = summary.reduce((sum, item) => {
  return sum + (item.price * item.count);
}, 0);

const total = basePrice + charmsTotal;

container.innerHTML += `
  <div style="margin-top:40px;">
    <div style="
  max-width:650px;
  margin:40px auto;
  padding:20px 20px 10px;
  background:#fafafa;
  border-radius:10px;
">
  <h3 style="text-align:center; margin-bottom:10px;">
    Selected Charms
  </h3>

    ${summary.length === 0 ? `
      <p style="text-align:center;">No charms selected</p>
    ` : `
      
      <div style="
  max-width:600px;
  margin:40px auto;
">

  ${summary.length === 0 ? `
    <div style="text-align:center; color:#888;">
      No charms selected
    </div>
  ` : `
    ${summary.map(item => `
      <div style="
        display:flex;
        justify-content:space-between;
        align-items:center;
        padding:14px 0;
        border-bottom:1px solid #eee;
      ">

        <div style="display:flex; align-items:center; gap:12px;">
          <img src="${item.img}" style="width:42px; border-radius:4px;">
          <div>
            <div style="font-weight:500;">
              ${item.name}
            </div>
            <div style="font-size:13px; color:#777;">
              ${item.price} EGP
            </div>
          </div>
        </div>

        <button data-remove="${item.id}" style="
          background:none;
          border:none;
          font-size:16px;
          color:#aaa;
          cursor:pointer;
        ">✕</button>

      </div>
    `).join("")}

    <!-- totals -->
    <div style="margin-top:20px; font-size:14px;">

      <div style="
        display:flex;
        justify-content:space-between;
        color:#777;
        margin-bottom:6px;
      ">
        <span>Bracelet</span>
        <span>${basePrice} EGP</span>
      </div>

      <div style="
        display:flex;
        justify-content:space-between;
        font-size:18px;
        font-weight:600;
      ">
        <span>Total</span>
        <span>${total} EGP</span>
      </div>

    </div>
  `}
</div>


    
      </div>
    `}
  </div>




<div style="text-align:center; margin-top:40px;">
  <button id="add-to-cart" style="
    background:#000;
    color:#fff;
    padding:14px 32px;
    letter-spacing:0.5px;
    border:none;
    cursor:pointer;
    font-size:14px;
  ">
    Add to Cart
  </button>
</div>

<div style="text-align:center; margin-top:10px;">
  <button id="share-design" style="
    background:#f5f5f5;
    color:#000;
    padding:12px 28px;
    margin-top:10px;
    border:none;
    cursor:pointer;
    font-size:13px;
  ">
    Share Design
  </button>
</div>

`;


//slot select
    container.querySelectorAll("[data-index]").forEach(el => {
  const index = Number(el.dataset.index);

  let clickTimer = null;

  el.onclick = () => {
    if (clickTimer) return;

    clickTimer = setTimeout(() => {
      selectedSlot = index;
      render();
      clickTimer = null;
    }, 200);
  };

  el.ondblclick = () => {
    clearTimeout(clickTimer);
    clickTimer = null;

    if (slots[index].type === "base") return;

    slots[index] = {
      type: "base",
      img: getBaseImage(index)
    };

    selectedSlot = null;
    saveDesign();
    render();
  };
});

//mobile slot select version
let lastTap = 0;

container.querySelectorAll("[data-index]").forEach(el => {
  el.addEventListener("touchend", () => {
    const now = new Date().getTime();
    const index = Number(el.dataset.index);

    if (now - lastTap < 300) {
      // double tap detected
      if (slots[index].type !== "base") {
        slots[index] = {
          type: "base",
          img: getBaseImage(index)
        };

        selectedSlot = null;
        saveDesign();
        render();
      }
    }

    lastTap = now;
  });
});

   // normal charm
container.querySelectorAll("[data-charm]").forEach(el => {
  el.onclick = () => {
    if (selectedSlot === null) return;

    const index = selectedSlot;

    slots[index] = {
      type: "charm",
      img: charms[el.dataset.charm].img
    };

    selectedSlot = null;
    saveDesign();
    render();

    // 👉 SNAP EFFECT
    setTimeout(() => {
      const slotEl = container.querySelector(`[data-index="${index}"] img`);
      if (!slotEl) return;

      slotEl.style.transform += " scale(1.15)";

      setTimeout(() => {
        slotEl.style.transform = slotEl.style.transform.replace(" scale(1.15)", "");
      }, 150);
    }, 10);
  };
});

    
    // hanging charm
container.querySelectorAll("[data-hanging]").forEach(el => {
  el.onclick = () => {
    if (selectedSlot === null) return;

    const index = selectedSlot;

    slots[index] = {
      type: "hanging",
      img: hangingCharms[el.dataset.hanging].img
    };

    selectedSlot = null;
    saveDesign();
    render();
   
    // 👉 SNAP EFFECT
    setTimeout(() => {
      const slotEl = container.querySelector(`[data-index="${index}"] img`);
      if (!slotEl) return;

      slotEl.style.transform += " scale(1.15)";

      setTimeout(() => {
        slotEl.style.transform = slotEl.style.transform.replace(" scale(1.15)", "");
      }, 150);
    }, 10);
  };
});

    // style
    container.querySelectorAll("[data-style]").forEach(el => {
      el.onclick = () => {
        braceletStyle = el.dataset.style;
        saveDesign();
        render();
      };
    });


    // remove
    container.querySelectorAll("[data-remove]").forEach(btn => {
  btn.onclick = () => {
    const id = btn.dataset.remove;

    let removed = false;

    slots = slots.map(slot => {
      if (!removed && slot.type !== "base") {
        const charmData = [...charms, ...hangingCharms].find(c => c.img === slot.img);
        if (charmData && charmData.id === id) {
          removed = true;
          return { type: "base", img: getBaseImage(0) };
        }
      }
      return slot;
    });
    saveDesign();
    render();
  };
});


//share button
const shareBtn = container.querySelector("#share-design");

if (shareBtn) {
  shareBtn.onclick = () => {
    const link = generateShareLink();

    navigator.clipboard.writeText(link);

    alert("Link copied ✨");
  };
}


const addBtn = container.querySelector("#add-to-cart");

if (addBtn) {
  addBtn.onclick = async () => {

  const summary = getSummary();

  const items = [];

  // 👉 Add bracelet base
  items.push({
    id: BASE_VARIANTS[braceletStyle],
    quantity: 1,
    properties: {
      Style: braceletStyle
    }
  });

  // 👉 Add each charm
  summary.forEach(item => {
    items.push({
      id: item.variantId,
      quantity: item.count,
      properties: {
        Slots: getSlotsForCharm(item.id)
      }
    });
  });

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  });

  window.location.href = "/cart";
};
}

const newScrollContainer = container.querySelector(".bracelet-scroll");
if (newScrollContainer) {
  newScrollContainer.scrollTo({
  left: scrollLeft,
  behavior: "instant"
});
}
  }

  loadFromURL();
  loadDesign();
  render();
});